import 'whatwg-fetch';
import axios from 'axios';

// const LOG_URL = '//localhost:5000/cookie-control-response/log';
const LOG_URL = '//dev.istack.network/cookie-control-response/log';
const GEOIP_URL = '//geo.istack.network/netacuity-server-1.0/resolveIP/'
// const GEOIP_URL = 'http://45.32.166.177/netacuity-server-1.0/resolveIP/'

export function executeScriptsBySettingName(dataAttribValues) {
  if (Array.isArray(dataAttribValues)) {
    dataAttribValues.forEach((attrib) => {
      document.querySelectorAll(`script[data-icc=${attrib}]:not([data-icc-loaded])`).forEach((e) => {
        if (e.src) {
          const stag = document.createElement('script');
          stag.setAttribute('src', e.src);
          stag.setAttribute('data-icc-loaded', true);
          e.setAttribute('data-icc-loaded', true);
          e.parentElement.append(stag);
          e.parentElement.removeChild(e);
        }
        if (e.innerHTML) {
          e.setAttribute('data-icc-loaded', true);
          (new Function(e.innerHTML))();
        }
      });
    })
  }
}

export function isArrayEqual(prev, current) {
  return prev ? (prev.length === current.length && prev.every((v, i) => v === current[i])) : true;
}

export function logResponse(response = [], country = 'EU', callback=()=>{}) {

  axios.post(LOG_URL, 
  {
    ans:response, 
    ctry: country
  })
  .then((response) => {callback(null, response)})
  .catch((ex) => {callback(ex, null)});
}

export async function getGeoIP(){
  return await axios.get(GEOIP_URL);
}


// WEBPACK FOOTER //
// ./src/helpers.js